<style scoped>
    @font-face {
            font-family: SourceSansPro-Regular;
            src: url(../assets/fonts/SourceSansPro-Regular.ttf);
        }

        .clearfix:after {
          content: "";
          display: table;
          clear: both;
        }

        a {
          color: #0087C3;
          text-decoration: none;
        }

        body {
          position: relative;
          width: 21cm;
          height: 29.7cm;
          margin: 0 auto;
          color: #000;
          background: #FFFFFF;
          font-family: SourceSansPro-Regular.ttf;
          font-size: 14px;
          font-family: SourceSansPro-Regular.ttf;
        }

        header {
          padding: 2px 0;
          margin-bottom: 2px;
          border-bottom: 1px solid #AAAAAA;
        }

        #logo {
          float: left;
          margin-top: 8px;
        }

        #logo img {
            height: 70px;
        }

        #company {
          float: center;
          text-align: center;
        }

        #passdetails {
          padding-right: 6px;
          float: right;
          text-align: left;
        }

        #taxinvoice {
          float: center;
          text-align: center;
          width: 100%;
          font-size: 1.4em;
          font-weight: bold;
          text-transform: uppercase;
        }


        #details {
          margin-bottom: 10px;
        }

        #client {
          padding-left: 2px;
          border-left: 6px solid #0087C3;
          float: left;
        }

        #client .to {
          color: #000;
        }

        h2.name {
          font-size: 1.0em;
          font-weight: normal;
          margin: 0;
        }

        #invoice {
          float: right;
          text-align: right;
        }

        #invoice h1 {
          color: #000;
          font-size: 1.2em;
          line-height: 0.2em;
          font-weight: normal;
          margin: 0  0 1px 0;
        }

        #invoice .date {
          font-size: 1.0em;
          color: #000;
        }

        #invoice .line {
          font-size: 1.2em;
          color: #000;
          font-weight: bold;
        }

        table {
          width: 100%;
          font-size: 1.0em;
          border-collapse: collapse;
          border-spacing: 0;
          margin-bottom: 2px;
          background: #fff;
        }


        table td {
          padding: 2px;
          background: #fff;
          text-align: center;
        }

        table th {
          padding: 4px;
          white-space: nowrap;
          font-size: 1.0em;
          font-color: #fff;
          font-weight: bold;
          background-color: #EEEEEE;
          text-align: center;
        }

        table td {
          text-align: center;
        }

        table td h3{
          color: #000;
          font-size: 1.0em;
          font-weight: normal;
          margin: 0 0 0.2em 0;
        }

        table .history {
          padding: 3px;
          font-size: 1.0em;
          background: #fff;
          text-align: left;
          border-top: 1px solid #AAAAAA;
        }
        table .no {
          color: #000;
          background: #fff;
        }

        table .desc {
          text-align: center;
          font-size: 1.0em;
          background: #fff;
        }

        table .shipper {
          text-align: center;
          font-size: 1.0em;
          background: #fff;
        }

        table .gst {
          text-align: center;
          font-size: 1.0em;
          background: #fff;
        }

        table .sheaderl {
          text-align: right;
          font-size: 1.0em;
          background: #fff;
        }

        table .sheaderr {
          text-align: left;
          font-size: 1.0em;
          background: #fff;
        }

        table .sign {
          text-align: right;
          font-size: 1.0em;
          background: #fff;
        }

        table .words {
          text-align: left;
          font-size: 1.0em;
          background: #EEEEEE;
        }

        table .unit {
          text-align: center;
          background: #fff;
        }

        table .qty {
          text-align: center;
          background: #fff;
        }

        table .total {
          text-align: center;
          background: #fff;
        }
        table td.desc,
        table td.unit,
        table td.qty,
        table td.total {
          font-size: 1.0em;
        }

        table tbody tr:last-child td {
          border: none;
        }

        table tfoot td {
          padding: 2px;
          background: #FFFFFF;
          border-bottom: none;
          font-size: 1.2em;
          white-space: nowrap;
          border-top: 1px solid #AAAAAA;
        }

        table tfoot tr:first-child td {
          border-top: none;
        }

        table tfoot tr:last-child td {
          color: #000;
          padding-top: 20px;
          font-size: 1.0em;
          border-top: 1px solid #57B223;

        }

        table tfoot tr td:first-child {
          border: none;
        }

        #taxable {
          text-align: center;
        }

        #id {
            text-align: left;
            font-size: 1.0em;
            background: #fff;
        }

        #thanks{
          font-size: 1em;
          margin-bottom: 50px;
        }

        #notices{
          padding-left: 6px;
          border-left: 6px solid #0087C3;
        }

        #notices .notice {
          font-size: 1.2em;
        }

        footer {
          color: #000;
          width: 100%;
          height: 25px;
          position: absolute;
          padding: 8px 0;
          text-align: center;
        }


</style>

<template>
    <v-layout>
        <body>
          <div>
        <header class="clearfix">
            <div id="logo">
                <img src="../assets/logo.png" class="d-inline-block align-top" alt="">
            </div>
            <div id="company">
                <h2 class="name" style="font-weight: bold;">VILSONS CONTAINER FREIGHT STATION</h2>
                <div>(A Unit of Vilsons Shipping Private Limited)</div>
                <div style="font-weight: bold;">33AAACV6328H1ZF</div>
                <div>3/2B, Harbour Express Road, Near Camp I, Tuticorin - 628 006</div>
                <div>Ph.No.: 0461-2352955,2352055,7373012055 | vilsons.cfs@gmail.com | www.cfs.vilsonsshipping.com</div>
            </div>
            <div style="text-align: center;
              font-size: 20px; font-weight: bold;">CONTAINER HISTORY
            </div>
            <br />
            <table border="0.5" cellspacing="0" cellpadding="0">
                <thead>
                    <tr>
                        <th>Container</th>
                        <th>Size/type</th>
                        <th>IGM</th>
                        <th>IGM Date</th>
                        <th>BL</th>
                    </tr>
                </thead>
                <tbody>
                    <tr>
                        <td class="desc">{{ history_details.container_no }}</td>
                        <td class="unit">{{ history_details.sizetype }}</td>
                        <td class="unit">{{ history_details.igm_no }}</td>
                        <td class="unit">{{ history_details.igm_date }}</td>
                        <td class="unit">{{ history_details.bl_no }}</td>
                    </tr>
                </tbody>
            </table>
            <table border="0.5" cellspacing="0" cellpadding="0">
                <thead>
                    <tr>
                        <th>Line</th>
                        <th>Vessel</th>
                        <th>Voyage</th>
                        <th>Work Order</th>
                    </tr>
                </thead>
                <tbody>
                    <tr>
                        <td class="desc">{{ history_details.line }}</td>
                        <td class="unit">{{ history_details.vessel }}</td>
                        <td class="unit">{{ history_details.voyage }}</td>
                        <td class="unit">{{ history_details.file_no }}</td>
                    </tr>
                </tbody>
            </table>
        </header>
        <main>
        <hr />
        <div style="text-align: center; font-size: 16px; padding-top:25px;" v-if="!history_details.gatein">No Gate In Records Found</div>
        <div  v-if="history_details.gatein">
            <div style="text-align: center; font-size: 16px; text-decoration: underline; text-decoration-color: #1769aa; font-weight: bold;">GATE IN
            </div>
            <br />
            <table border="0.8">
                <tbody>
                    <tr>
                        <td class="history">Pass No</td>
                        <td class="history">{{ history_details.gatein_result.gin_pass_no }}</td>
                        <td class="history">In Date</td>
                        <td class="history">{{ history_details.gatein_result.gin_cfs_in_time }}</td>
                    </tr>
                    <tr>
                        <td class="history">Truck Details</td>
                        <td class="history">{{ history_details.gatein_result.gin_truck_no }}&nbsp;&amp;&nbsp;{{ history_details.gatein_result.gin_transporter }}</td>
                        <td class="history">Port Out</td>
                        <td class="history">{{ history_details.gatein_result.gin_terminal_out_Time }}</td>
                    </tr>
                </tbody>
            </table>
            <hr />
        </div>
        <div style="text-align: center; font-size: 16px; padding-top:25px;" v-if="!history_details.seal_break">No Seal Break Records Found</div>
        <div  v-if="history_details.seal_break">
            <div style="text-align: center; font-size: 16px; text-decoration: underline; text-decoration-color: #1769aa; font-weight: bold;">SEAL Break
            </div>
            <br />
            <table border="0.8">
                <tbody>
                    <tr>
                        <td class="history">Delivery Mode</td>
                        <td class="history">{{ history_details.seal_break_result.sb_delivery_mode }}</td>
                        <td class="history">Seal Break Date</td>
                        <td class="history">{{ history_details.seal_break_result.sb_date }}</td>
                    </tr>
                    <tr>
                        <td class="history">Bill of Entry</td>
                        <td class="history">{{ history_details.seal_break_result.sb_be_no }}</td>
                        <td class="history">BE Date</td>
                        <td class="history">{{ history_details.seal_break_result.sb_be_date }}</td>
                    </tr>
                    <tr>
                        <td class="history">CHA</td>
                        <td class="history">{{ history_details.seal_break_result.sb_customer }}</td>
                        <td class="history">Importer</td>
                        <td class="history">{{ history_details.seal_break_result.sb_importer }}</td>
                    </tr>
                </tbody>
            </table>
            <hr />
        </div>
        <div  v-if="history_details.fcl">
            <div style="text-align: center; font-size: 16px; text-decoration: underline; text-decoration-color: #1769aa; font-weight: bold;">FCL Out
            </div>
            <br />
            <table border="0.8">
                <tbody>
                    <tr>
                        <td class="history">Out Date</td>
                        <td class="history">{{ history_details.fcl_result.fcl_out_time }}</td>
                        <td class="history">Pass No</td>
                        <td class="history">{{ history_details.fcl_result.fcl_pass_no }}</td>
                    </tr>
                    <tr>
                        <td class="history">Custom-Line Seal</td>
                        <td class="history">{{ history_details.fcl_result.fcl_seal_no }}&nbsp;&amp;&nbsp;{{ history_details.fcl_result.fcl_line_seal }}</td>
                        <td class="history">Truck</td>
                        <td class="history">{{ history_details.fcl_result.fcl_truck }}</td>
                    </tr>
                </tbody>
            </table>
        </div>
        <div  v-if="history_details.ds">
            <div style="text-align: center; font-size: 16px; text-decoration: underline; text-decoration-color: #1769aa; font-weight: bold;">De-Stuff Out
            </div>
            <br />
            <table border="0.8">
                <tbody>
                    <tr>
                        <td class="history">Out Date</td>
                        <td class="history">{{ history_details.ds_result.ds_out_time }}</td>
                        <td class="history">Pass No</td>
                        <td class="history">{{ history_details.ds_result.ds_pass_no }}</td>
                    </tr>
                    <tr>
                        <td class="history">Cargo Details</td>
                        <td class="history">{{ history_details.ds_result.ds_cargo_description }}</td>
                        <td class="history">Truck</td>
                        <td class="history">{{ history_details.ds_result.ds_truck_no }}</td>
                    </tr>
                    <tr>
                        <td class="history">Quantity</td>
                        <td class="history">{{ history_details.ds_result.ds_quantity }}</td>
                        <td class="history">Unit</td>
                        <td class="history">{{ history_details.ds_result.ds_package_unit }}</td>
                    </tr>
                </tbody>
            </table>
        </div>
        <div  v-if="history_details.mty">
            <div style="text-align: center; font-size: 16px; text-decoration: underline; text-decoration-color: #1769aa; font-weight: bold;">Empty Container Out
            </div>
            <br />
            <table border="0.8">
                <tbody>
                    <tr>
                        <td class="history">Out Date</td>
                        <td class="history">{{ history_details.mty_result.mty_out_time }}</td>
                        <td class="history">Pass No</td>
                        <td class="history">{{ history_details.mty_result.mty_pass_no }}</td>
                    </tr>
                    <tr>
                        <td class="history">Party Name</td>
                        <td class="history">{{ history_details.mty_result.mty_party_name }}</td>
                        <td class="history">Truck</td>
                        <td class="history">{{ history_details.mty_result.mty_truck_no }}</td>
                    </tr>
                    <tr>
                        <td class="history">To Yard</td>
                        <td class="history">{{ history_details.mty_result.mty_location }}</td>
                        <td class="history">Driver Name</td>
                        <td class="history">{{ history_details.mty_result.mty_driver_name }}</td>
                    </tr>
                </tbody>
            </table>
        </div>            
        <footer>
          This is generated on a computer and is valid without the signature and seal.<br/>
          for enquiry please mail us on managercfs@vilship.com. Thanks for your business!
        </footer>
            </main>
            </div>
        </body>
    </v-layout>
</template>

<script>
import axios from 'axios';
export default {
    name: 'history',
    data() {
        return {
            history_details: [],
            pass_no: null,
            in_date: null,
            port_out_time: null,
            igm_no: null,
            igm_date: null,
            bl_no: null,
            bl_date: null,
            vessel: null,
            voyage: null,
            line: null,
            transporter: null,
            cargo: null,
            importer: null,
            is_scanned: null,
            eir_no: null,
            job_order_no: null,
        }
    },
    mounted:function() {
        this.getData()
    },
    methods: {
      getData: function () {
            this.loading = true;
            this.API_URL = this.$hostname + "/print/history?cont_id=" + this.$route.params.cont_id
            axios.get(this.API_URL, { headers: {"Authorization" : 'jwt ' + localStorage.jwt} })
            .then((response) => {
                this.loading = false;
                this.history_details = response.data;
            }, (error) => {
                this.loading = false;
                this.error = true;
            })
        }
    }
}
</script>